import React from 'react';
import {observer} from 'mobx-react';
import {Link} from 'react-router-dom';
import bundleStore from '../../../store/bundleStore';
import shopStore from '../../../store/shopStore';
import roomStore from '../../../store/roomStore';
import BundleList from '../../room/contents/BundleList';

export default observer(function BundleDone({onHome}) {
    const {orders, total} = bundleStore.result;
    const shopName = shopStore.shopInfo?.spName || roomStore.shopData?.spName;
    return <>
        <header className="bundle-done-card bundle-done-header" role="status">
            <span className="bundle-done-check" aria-hidden="true">
                <svg viewBox="0 0 32 32" width="32" height="32" fill="none" focusable="false">
                    <path d="m8 16 5.5 5.5L24 11" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </span>
            <h1>예약이 완료되었습니다</h1>
            <p className="bundle-done-caption bundle-done-summary">{shopName && <>{shopName} · </>}총 {orders.length}건 · <span className="bundle-done-amount">합계 {total.toLocaleString('ko-KR')}원</span></p>
        </header>
        <BundleList complete />
        <aside className="bundle-done-notice" aria-label="취소 및 환불 안내">
            <p>이용권과 동일하게, 예약 중 한 건이라도 이용이 시작되면 나머지 미이용 예약을 포함해 카드 환불이 불가합니다.</p>
            <p>이용 시작 전에는 예약 전체 취소만 가능합니다.</p>
        </aside>
        <div className="reserved_btn bundle-done-actions">
            <Link className="bundle-done-primary" to="/my">내 예약 보기</Link>
            <button type="button" className="bundle-done-home" onClick={onHome}>홈으로</button>
        </div>
    </>;
});
